import React from 'react';
import { FormData } from '../types/formTypes';

interface DetailedInfoFormProps {
  formData: FormData;
  updateFormData: (updates: Partial<FormData>) => void;
}

const DetailedInfoForm: React.FC<DetailedInfoFormProps> = ({ formData, updateFormData }) => {
  return (
    <div className="form-section">
      <h2>訓練詳細情報</h2>
      
      <div className="form-group">
        <label>OFF-JT訓練種別 *</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="offJtType"
              value="事業内（部内講師）"
              checked={formData.offJtType === '事業内（部内講師）'}
              onChange={(e) => updateFormData({ offJtType: e.target.value as any })}
            />
            ①ア 事業内訓練（部内講師）
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="offJtType"
              value="事業内（部外講師）"
              checked={formData.offJtType === '事業内（部外講師）'}
              onChange={(e) => updateFormData({ offJtType: e.target.value as any })}
            />
            ①イ 事業内訓練（部外講師）
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="offJtType"
              value="事業外"
              checked={formData.offJtType === '事業外'}
              onChange={(e) => updateFormData({ offJtType: e.target.value as any })}
            />
            ② 事業外訓練
          </label>
        </div>
      </div>

      {(formData.offJtType === '事業内（部内講師）' || formData.offJtType === '事業内（部外講師）') && (
        <div className="form-group">
          <label htmlFor="instructorNames">OFF-JT講師の氏名</label>
          <textarea
            id="instructorNames"
            value={formData.instructorNames || ''}
            onChange={(e) => updateFormData({ instructorNames: e.target.value })}
            rows={3}
            placeholder="講師の氏名を入力してください"
          />
        </div>
      )}

      {formData.offJtType === '事業外' && (
        <div className="training-institution-section">
          <h3>教育訓練機関の詳細情報</h3>
          
          <div className="form-group">
            <label htmlFor="institutionName">①教育訓練機関の名称 *</label>
            <input
              type="text"
              id="institutionName"
              value={formData.trainingInstitution?.name || ''}
              onChange={(e) => updateFormData({
                trainingInstitution: {
                  ...formData.trainingInstitution,
                  name: e.target.value,
                  representativeName: formData.trainingInstitution?.representativeName || '',
                  address: formData.trainingInstitution?.address || '',
                  contractBackground: formData.trainingInstitution?.contractBackground || '',
                  selectionTrigger: formData.trainingInstitution?.selectionTrigger || '営業を受けた',
                  loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                  advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                  materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                  paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                }
              })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="institutionRepresentative">②教育訓練機関の代表者名 *</label>
            <input
              type="text"
              id="institutionRepresentative"
              value={formData.trainingInstitution?.representativeName || ''}
              onChange={(e) => updateFormData({
                trainingInstitution: {
                  ...formData.trainingInstitution,
                  name: formData.trainingInstitution?.name || '',
                  representativeName: e.target.value,
                  address: formData.trainingInstitution?.address || '',
                  contractBackground: formData.trainingInstitution?.contractBackground || '',
                  selectionTrigger: formData.trainingInstitution?.selectionTrigger || '営業を受けた',
                  loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                  advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                  materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                  paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                }
              })}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="institutionAddress">③教育訓練機関の所在地 *</label>
            <input
              type="text"
              id="institutionAddress"
              value={formData.trainingInstitution?.address || ''}
              onChange={(e) => updateFormData({
                trainingInstitution: {
                  ...formData.trainingInstitution,
                  name: formData.trainingInstitution?.name || '',
                  representativeName: formData.trainingInstitution?.representativeName || '',
                  address: e.target.value,
                  contractBackground: formData.trainingInstitution?.contractBackground || '',
                  selectionTrigger: formData.trainingInstitution?.selectionTrigger || '営業を受けた',
                  loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                  advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                  materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                  paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                }
              })}
              required
            />
          </div>


          <div className="form-group">
            <label>訓練実施に関する営業・情報収集のきっかけ</label>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="selectionTrigger"
                  value="営業を受けた"
                  checked={formData.trainingInstitution?.selectionTrigger === '営業を受けた'}
                  onChange={(e) => updateFormData({
                    trainingInstitution: {
                      ...formData.trainingInstitution,
                      name: formData.trainingInstitution?.name || '',
                      representativeName: formData.trainingInstitution?.representativeName || '',
                      address: formData.trainingInstitution?.address || '',
                      contractBackground: formData.trainingInstitution?.contractBackground || '',
                      selectionTrigger: e.target.value as any,
                      loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                      advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                      materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                      paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                    }
                  })}
                />
                訓練実施に関する営業を受けた
              </label>
            </div>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="selectionTrigger"
                  value="自ら検索"
                  checked={formData.trainingInstitution?.selectionTrigger === '自ら検索'}
                  onChange={(e) => updateFormData({
                    trainingInstitution: {
                      ...formData.trainingInstitution,
                      name: formData.trainingInstitution?.name || '',
                      representativeName: formData.trainingInstitution?.representativeName || '',
                      address: formData.trainingInstitution?.address || '',
                      contractBackground: formData.trainingInstitution?.contractBackground || '',
                      selectionTrigger: e.target.value as any,
                      loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                      advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                      materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                      paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                    }
                  })}
                />
                自ら検索してニーズに合う訓練を見つけた
              </label>
            </div>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  name="selectionTrigger"
                  value="その他"
                  checked={formData.trainingInstitution?.selectionTrigger === 'その他'}
                  onChange={(e) => updateFormData({
                    trainingInstitution: {
                      ...formData.trainingInstitution,
                      name: formData.trainingInstitution?.name || '',
                      representativeName: formData.trainingInstitution?.representativeName || '',
                      address: formData.trainingInstitution?.address || '',
                      contractBackground: formData.trainingInstitution?.contractBackground || '',
                      selectionTrigger: e.target.value as any,
                      loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                      advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                      materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                      paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                    }
                  })}
                />
                その他
              </label>
            </div>
            {formData.trainingInstitution?.selectionTrigger === 'その他' && (
              <div className="form-group">
                <input
                  type="text"
                  value={formData.trainingInstitution?.selectionTriggerOther || ''}
                  onChange={(e) => updateFormData({
                    trainingInstitution: {
                      name: formData.trainingInstitution?.name || '',
                      representativeName: formData.trainingInstitution?.representativeName || '',
                      address: formData.trainingInstitution?.address || '',
                      contractBackground: formData.trainingInstitution?.contractBackground || '',
                      selectionTrigger: formData.trainingInstitution?.selectionTrigger || '営業を受けた',
                      loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                      advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                      materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                      paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                      selectionTriggerOther: e.target.value
                    }
                  })}
                  placeholder="その他の詳細を入力してください"
                />
              </div>
            )}
          </div>


          <div className="form-group">
            <label>確認事項</label>
            <div className="radio-group">
              <label>
                <input
                  type="checkbox"
                  checked={formData.trainingInstitution?.advertisingConfirmation || false}
                  onChange={(e) => updateFormData({
                    trainingInstitution: {
                      ...formData.trainingInstitution,
                      name: formData.trainingInstitution?.name || '',
                      representativeName: formData.trainingInstitution?.representativeName || '',
                      address: formData.trainingInstitution?.address || '',
                      contractBackground: formData.trainingInstitution?.contractBackground || '',
                      selectionTrigger: formData.trainingInstitution?.selectionTrigger || '営業を受けた',
                      loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                      advertisingConfirmation: e.target.checked,
                      materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                      paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                    }
                  })}
                />
                広告宣伝業務に関する確認
              </label>
            </div>
            <div className="radio-group">
              <label>
                <input
                  type="checkbox"
                  checked={formData.trainingInstitution?.materialConfirmation || false}
                  onChange={(e) => updateFormData({
                    trainingInstitution: {
                      ...formData.trainingInstitution,
                      name: formData.trainingInstitution?.name || '',
                      representativeName: formData.trainingInstitution?.representativeName || '',
                      address: formData.trainingInstitution?.address || '',
                      contractBackground: formData.trainingInstitution?.contractBackground || '',
                      selectionTrigger: formData.trainingInstitution?.selectionTrigger || '営業を受けた',
                      loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                      advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                      materialConfirmation: e.target.checked,
                      paymentConfirmation: formData.trainingInstitution?.paymentConfirmation || false,
                    }
                  })}
                />
                説明資料提供確認
              </label>
            </div>
            <div className="radio-group">
              <label>
                <input
                  type="checkbox"
                  checked={formData.trainingInstitution?.paymentConfirmation || false}
                  onChange={(e) => updateFormData({
                    trainingInstitution: {
                      ...formData.trainingInstitution,
                      name: formData.trainingInstitution?.name || '',
                      representativeName: formData.trainingInstitution?.representativeName || '',
                      address: formData.trainingInstitution?.address || '',
                      contractBackground: formData.trainingInstitution?.contractBackground || '',
                      selectionTrigger: formData.trainingInstitution?.selectionTrigger || '営業を受けた',
                      loadReductionProposal: formData.trainingInstitution?.loadReductionProposal || '',
                      advertisingConfirmation: formData.trainingInstitution?.advertisingConfirmation || false,
                      materialConfirmation: formData.trainingInstitution?.materialConfirmation || false,
                      paymentConfirmation: e.target.checked,
                    }
                  })}
                />
                金銭提供なしの確認
              </label>
            </div>
          </div>
        </div>
      )}
      
      <div className="form-group">
        <label>デジタル人材の育成を目的に行う訓練の場合</label>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="digitalTrainingCategory"
              value="businessArchitect"
              checked={formData.digitalTrainingCategory === 'businessArchitect'}
              onChange={(e) => updateFormData({ digitalTrainingCategory: e.target.value as any })}
            />
            ①ビジネスアーキテクト関係
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="digitalTrainingCategory"
              value="dataScientist"
              checked={formData.digitalTrainingCategory === 'dataScientist'}
              onChange={(e) => updateFormData({ digitalTrainingCategory: e.target.value as any })}
            />
            ②データサイエンティスト関係
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="digitalTrainingCategory"
              value="softwareEngineer"
              checked={formData.digitalTrainingCategory === 'softwareEngineer'}
              onChange={(e) => updateFormData({ digitalTrainingCategory: e.target.value as any })}
            />
            ③ソフトウェアエンジニア関係
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="digitalTrainingCategory"
              value="cyberSecurity"
              checked={formData.digitalTrainingCategory === 'cyberSecurity'}
              onChange={(e) => updateFormData({ digitalTrainingCategory: e.target.value as any })}
            />
            ④サイバーセキュリティ関係
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="digitalTrainingCategory"
              value="designer"
              checked={formData.digitalTrainingCategory === 'designer'}
              onChange={(e) => updateFormData({ digitalTrainingCategory: e.target.value as any })}
            />
            ⑤デザイナー関係
          </label>
        </div>
        <div className="radio-group">
          <label>
            <input
              type="radio"
              name="digitalTrainingCategory"
              value="other"
              checked={formData.digitalTrainingCategory === 'other'}
              onChange={(e) => updateFormData({ digitalTrainingCategory: e.target.value as any })}
            />
            ⑥その他のデジタル人材関係
          </label>
        </div>
      </div>
      
      <div className="form-group">
        <label htmlFor="careerCenterName">
          有期実習型訓練・認定実習併用職業訓練・情報技術分野認定実習併用職業訓練であって、キャリア形成・リスキリング支援センターに以下の書類（写）の送付を希望する場合は、送付先のセンター名を記載してください。
          <br />
          ・「職業訓練実施計画届」（様式第1-1号）
          <br />
          ・ジョブ・カード様式3-3-1-1（職業能力証明（訓練成果・実務成果）シート）
        </label>
        <input
          type="text"
          id="careerCenterName"
          value={formData.careerCenterName || ''}
          onChange={(e) => updateFormData({ careerCenterName: e.target.value })}
          placeholder="送付先のセンター名を入力してください"
        />
      </div>
    </div>
  );
};

export default DetailedInfoForm;